angular.module('pitch.app')

.filter('asset', function() {
    return function(assets, key) {
        if (assets) {
            for (var i = 0; i <= assets.length - 1; i++) {
                if (assets[i].key === key) {
                    return assets[i];
                }
            }
        }
    };
});


// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/filters/asset.js